/**
 * Brunetti Shipping Methods JavaScript
 * 
 * Handles the shipping method selection UI functionality on the checkout page.
 */
(function($) {
    // Function to toggle "open" class on payment review section
    function setupPaymentTitleToggle() {
        $('.checkout-payment__title-wrapper').on('click', function(e) {
            e.preventDefault();
            $('.woocommerce-checkout-review-order-wrapper.mobile-accordion').toggleClass('open');
            
            // Optional: Toggle an indicator on the title wrapper itself
            $(this).toggleClass('active');
        });
    }

    // Run when the document is ready
    $(document).ready(function() {
        setupPaymentTitleToggle();
    });

    // Also run after AJAX completes in case elements are reloaded
    $(document).ajaxComplete(function() {
        setupPaymentTitleToggle();
    });

    $('.woocommerce-checkout').on('change', '#checkout_pickup_store_location, .fulfilment-date-picker, #pick-up_slots', function () {
        $(document.body).trigger('update_checkout');
    });
})(jQuery);


jQuery(document).ready(function($) {
    $('#customer_details').on('change', '#use-shipping-details-for-billing', function (e) {
        if (e.target.checked) {
            copyDeliveryDetailsForBillingAndSaveOriginal();
        } else {
            restoreOriginalBillingDetails();
        }
    });
    $('#customer_details').on('change', [
        '#shipping_first_name',
        '#shipping_last_name',
        '#shipping_company',
        '#shipping_address_1',
        '#shipping_address_2',
        '#shipping_city',
        '#shipping_state',
        '#shipping_postcode',
        '#shipping_phone',
        '#shipping_country',
    ].join(','), function () {
        if ($('#use-shipping-details-for-billing').is(':checked')) {
            copyDeliveryDetailsForBillingAndSaveOriginal();
        }
    });
    if ($('#use-shipping-details-for-billing').is(':checked')) {
        copyDeliveryDetailsForBillingAndSaveOriginal();
    }

    // Validate contact email field
    function validateContactEmail() {
        var contactEmail = $('#contact_email').val().trim();
        var $contactEmailField = $('#contact_email_field');
        
        // Remove existing error styling
        $contactEmailField.removeClass('woocommerce-invalid');
        
        if (!contactEmail) {
            $contactEmailField.addClass('woocommerce-invalid');
            return false;
        }
        
        // Basic email validation
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(contactEmail)) {
            $contactEmailField.addClass('woocommerce-invalid');
            return false;
        }
        
        return true;
    }

    // Validate email on blur and input
    $('#contact_email').on('blur input', function() {
        validateContactEmail();
        
        // Copy contact email to billing email in real-time
        var contactEmail = $(this).val().trim();
        var billingEmailField = $('#billing_email');
        if (contactEmail && billingEmailField.length) {
            billingEmailField.val(contactEmail).trigger('change');
        }
    });

    // Validate email before form submission
    $('form.checkout').on('submit', function(e) {
        if (!validateContactEmail()) {
            e.preventDefault();
            e.stopPropagation();
            
            // Scroll to the email field
            $('html, body').animate({
                scrollTop: $('#contact_email').offset().top - 100
            }, 500);
            
            return false;
        }
    });

    $('#contact_email').on('change', function () {
        var contactEmail = $('#contact_email').val().trim();
        var billingEmailField = $('#billing_email');
        if (contactEmail && billingEmailField.length) {
            billingEmailField.val(contactEmail);
        }
        $(document.body).trigger('update_checkout');
    });

    var originalBillingDetails = null;
    function copyDeliveryDetailsForBillingAndSaveOriginal() {
        // Save original billing details before copying them from delivery details
        if (!originalBillingDetails) {
            originalBillingDetails = {};
            originalBillingDetails.firstName = $('#billing_first_name').val();
            originalBillingDetails.lastName = $('#billing_last_name').val();
            originalBillingDetails.company = $('#billing_company').val();
            originalBillingDetails.address1 = $('#billing_address_1').val();
            originalBillingDetails.address2 = $('#billing_address_2').val();
            originalBillingDetails.suburb = $('#billing_city').val();
            originalBillingDetails.state = $('#billing_state').val();
            originalBillingDetails.postcode = $('#billing_postcode').val();
            originalBillingDetails.phone = $('#billing_phone').val();
            originalBillingDetails.country = $('#billing_country').val();
        }

        // Copy from delivery details to billing details, and mark them as disabled
        $('#billing_first_name').val($('#shipping_first_name').val()).addClass('disabled').attr('readonly', 'readonly');
        $('#billing_last_name').val($('#shipping_last_name').val()).addClass('disabled').attr('readonly', 'readonly');
        $('#billing_company').val($('#shipping_company').val()).addClass('disabled').attr('readonly', 'readonly');
        $('#billing_address_1').val($('#shipping_address_1').val()).addClass('disabled').attr('readonly', 'readonly');
        $('#billing_address_2').val($('#shipping_address_2').val()).addClass('disabled').attr('readonly', 'readonly');
        $('#billing_city').val($('#shipping_city').val()).addClass('disabled').attr('readonly', 'readonly');
        $('#billing_state').val($('#shipping_state').val()).addClass('disabled').attr('readonly', 'readonly');
        $('#billing_postcode').val($('#shipping_postcode').val()).addClass('disabled').attr('readonly', 'readonly');
        $('#billing_phone').val($('#shipping_phone').val()).addClass('disabled').attr('readonly', 'readonly');
        $('#billing_country').val($('#shipping_country').val()).addClass('disabled').attr('readonly', 'readonly');
    }

    function restoreOriginalBillingDetails() {
        $('#billing_first_name').val(originalBillingDetails?.firstName || '').removeClass('disabled').removeAttr('readonly');
        $('#billing_last_name').val(originalBillingDetails?.lastName || '').removeClass('disabled').removeAttr('readonly');
        $('#billing_company').val(originalBillingDetails?.company || '').removeClass('disabled').removeAttr('readonly');
        $('#billing_address_1').val(originalBillingDetails?.address1 || '').removeClass('disabled').removeAttr('readonly');
        $('#billing_address_2').val(originalBillingDetails?.address2 || '').removeClass('disabled').removeAttr('readonly');
        $('#billing_city').val(originalBillingDetails?.suburb || '').removeClass('disabled').removeAttr('readonly');
        $('#billing_state').val(originalBillingDetails?.state || '').removeClass('disabled').removeAttr('readonly');
        $('#billing_postcode').val(originalBillingDetails?.postcode || '').removeClass('disabled').removeAttr('readonly');
        $('#billing_phone').val(originalBillingDetails?.phone || '').removeClass('disabled').removeAttr('readonly');
        $('#billing_country').val(originalBillingDetails?.country || '').removeClass('disabled').removeAttr('readonly');
        originalBillingDetails = null;
    }
});
